import type { AgenticCanvasEngine } from '@/store/features/userinfo/userinfoSlice';
import type { AgentId } from '@/api/weave-x-agents';

export type PlannerEngine = 'v2' | 'v4';
export type PlannerEngineGraphId = 'canvas_agent' | 'orchestrator_v4';

export const PLANNER_ENGINE_LABELS: Record<PlannerEngine, string> = {
  v2: 'v2',
  v4: 'v4',
};

export const PLANNER_ENGINE_NAMES: Record<PlannerEngine, string> = {
  v2: 'canvas_agent',
  v4: 'orchestrator_v4',
};

export const PLANNER_ENGINE_DESCRIPTIONS: Record<PlannerEngine, string> = {
  v2: 'Runs the current production planner.',
  v4: 'Runs the new planning graph. Required for Creative mode.',
};

export const PLANNER_ENGINE_V2_NOTICE =
  'This plan will run on v2 (canvas_agent). Creative needs v4.';

export function plannerEngineFromAgenticCanvasEngine(
  engine: AgenticCanvasEngine | null | undefined,
): PlannerEngine {
  return engine === 'v3' ? 'v4' : 'v2';
}

export function plannerEngineToAgentId(
  engine: PlannerEngine,
): Extract<AgentId, PlannerEngineGraphId> {
  return engine === 'v4' ? 'orchestrator_v4' : 'canvas_agent';
}

export function plannerEngineFromGraphId(graphId: unknown): PlannerEngine | null {
  if (graphId === 'orchestrator_v4') return 'v4';
  if (graphId === 'canvas_agent') return 'v2';
  return null;
}

function objectRecord(value: unknown): Record<string, unknown> | null {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null;
}

export function extractPlannerEngineFromThreadState(state: unknown): PlannerEngine | null {
  const record = objectRecord(state);
  const metadata = objectRecord(record?.metadata);
  return plannerEngineFromGraphId(metadata?.graph_id);
}
